<script>
import logo from '@/assets/images/polysigma-logo-dark.png'

export default {
    name: 'AppNavbar',
    data() {
        return {
            logo,
            links: [
                { hash: '#approach', name: 'Approach' },
                { hash: '#methods', name: 'Methods' },
                { hash: '#classification', name: 'Classification' },
                { hash: '#maintenance', name: 'Maintenance' },
                { hash: '#integration', name: 'Integration' },
            ],
        }
    },
}
</script>

<template>
    <b-navbar toggleable="lg" type="dark" sticky class="ps-navbar">
        <b-container>
            <b-navbar-brand :to="{ name: 'home' }" class="py-0">
                <b-img :src="logo" alt="PolySigma" class="ps-navbar__logo" />
            </b-navbar-brand>

            <b-navbar-toggle target="ps-nav" class="border-0 px-0">
                <template #default="{ expanded }">
                    <b-icon :icon="expanded ? 'x' : 'list'" font-scale="1.5" />
                </template>
            </b-navbar-toggle>

            <b-collapse id="ps-nav" is-nav>
                <b-navbar-nav class="ml-lg-auto align-items-lg-center py-3 py-lg-0">
                    <b-nav-item v-for="link in links" :key="link.hash" :to="{ name: 'home', hash: link.hash }">{{ link.name }}</b-nav-item>
                    <li class="nav-item ml-lg-3 mt-3 mt-lg-0">
                        <b-button :to="{ name: 'home', hash: '#beta' }" variant="primary" size="sm" class="ps-navbar__cta">Request beta access</b-button>
                    </li>
                </b-navbar-nav>
            </b-collapse>
        </b-container>
    </b-navbar>
</template>

<style scoped lang="scss">
.ps-navbar {
    background-color: rgba(3, 23, 38, 0.92);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--ps-rule);
}

.ps-navbar__logo {
    height: 1.75rem;
    width: auto;
}

.ps-navbar ::v-deep .nav-link {
    font-weight: 600;
}

.ps-navbar__cta {
    padding-left: 1.1rem;
    padding-right: 1.1rem;
}
</style>
